import { render, staticRenderFns } from "./Arrow3Rigth.vue?vue&type=template&id=21854cc8"
import script from "./Arrow3Rigth.vue?vue&type=script&lang=js"
export * from "./Arrow3Rigth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports